import React, { useState, useRef, useEffect, useCallback } from "react";

import {
    Box,
    Divider,
    TextField,
    Grid,
    Typography,
    Button,
    IconButton,
    InputAdornment,
    Container,
    Card,
    styled,
    FormHelperText,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    ListItemButton,
    List
} from '@mui/material';

import {
    LoadingButton
} from '@mui/lab';

import dayjs from "dayjs";

import { useNavigate, useSearchParams, useParams } from 'react-router-dom';

import { useFormik } from 'formik';

import { useAppContextFeatures } from "../../../context/AppContext";
import { useAuthAccess } from "../../../hooks/useAuthAccess";

import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from "../../common/CommonRestricted";
import DatePickerComponent from "../../common/DatePickerComponent";

import SearchItems from "../../dialog/SearchItems";
import SearchRetailMembers from "../../dialog/SearchRetailMembers";

import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../hooks/usePermissions";

import { CommonIcons, icons } from "../../common/CommonIcons";
import { useDocuments, documentTypes, targetTypes } from "../../../hooks/api/useDocuments";
import { useTranslations } from '../../../hooks/useTranslations';

import { useUsers, userTypes } from "../../../hooks/api/useUsers";

import { checkValueExists, calculateSummaryRows } from "../../../utils/dataSchema";
import { useDocumentAdjustments } from "../../../hooks/state/useDocumentAdjustments";

import {
    validationSchema,
    initialValues,
    initialRowValues,
} from "../../../schema/documents/retailPrescriptionSchema";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    // opacity: 0.1,
    //   backgroundColor: "green",
    //   color: 'inherit',
    //   display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

export default function UpdateRetailPrescription({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@document"] })

    const { id } = useParams();

    const navigate = useNavigate()
    // const [ searchParams, setSearchParams ] = useSearchParams()

    const { authData, getAvailableLocations } = useAuthAccess();
    const { getLocationIds, setLocationIds } = useAppContextFeatures();

    const { promptMessage } = useSystemPrompt();
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.document.id, scopeTypes.document.retailPrescription.id)

    const { setSystemLoading } = useAppContextFeatures();
    const { isLoading, update, get, filterOperatorTypes } = useDocuments({ 
        documentType: documentTypes.retailPrescription, 
        targetType: targetTypes.retailPrescription
    })
    const { get: getRetail } = useUsers({ userType: userTypes.retail });

    const [savedValues, setSavedValues] = useState()

    // const [ dataBranches, setDataBranches ] = useState([])
    // const [ dataShipping, setDataShipping ] = useState([])
    const [preview, setPreview] = useState(false)
    const [selectedAdjustments, setSelectedAdjustments] = useState([])

    const loadData = async (id) => {

        setSystemLoading(true)

        try {

            const { data } = await get({ id, dataTypesArray: ["adjustment"] })
            const { document, items } = data;

            // create rows
            const rows = items.map((i) => {
                return {
                    docItemId: i?.id,
                    itemId: i?.item_id,
                    name: i?.item_name,
                    code: i?.code,
                    description: i?.description,
                    qty: i?.qty,
                    uomName: i?.uom_name,
                    uomId: i?.uom_id,
                    price: i?.uom_price,
                    subtotal: i?.sub_price
                }
            })

            let _selectedAdjustments = document?.adjustments
            setSelectedAdjustments(_selectedAdjustments)

            setSavedValues({
                ...initialValues,
                locationId: document?.location_id,
                locationName: document?.location_name,
                documentNumber: document?.doc_number,
                documentDate: dayjs(document?.doc_date),
                remark: document?.doc_remark ? document.doc_remark : "",
                note: document?.note ? document.note : "",
                memberUserId: document?.user_id,
                memberDisplay: document?.profile_name,
                // shippingBranchId: document?.delivery_branch_id,
                // shippingBranchName: document?.delivery_profile_name,
                // billingBranchId: document?.billing_branch_id,
                // billingBranchName: document?.billing_profile_name,

                retailerUserId: authData?.profile?.parent_user_id,
                retailOutletBranchId: document?.retail_outlet_id,

                rows,

                totalamount: document?.total_amount,

            })

            // console.log('readTaxApiFormat(document)', readTaxApiFormat(document))

            // console.log('document', document?.userId)

            // get the branches
            // if(document?.user_id){
            //     fetchBranches(document?.user_id)
            // }


        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }

    // const fetchBranches = async (userId) => {

    //     try{

    //         const { data } = await getRetail({ id: userId, dataTypesArray: ["branch", "shipping_address"] })

    //         // console.log('data', data)

    //         setDataBranches(data?.retailer?.branches? data.retailer.branches : [])
    //         setDataShipping(data?.retailer?.shipping_addresses? data.retailer.shipping_addresses : [])

    //     }catch(error){
    //         promptMessage(false, `${error.message}`)
    //     }

    // }

    const onSubmit = async (currentValues) => {

        const document = {
            doc_date: currentValues.documentDate.format("YYYY-MM-DD"),
            doc_remark: currentValues.remark,
        }

        const props = {
            location_id: currentValues.locationId,
            retail_outlet_id: currentValues.retailOutletBranchId,
            note: currentValues.note,
        }

        const profiles = {
            member: {
                user_id: currentValues.memberUserId
            }
        }

        // const amounts = {
        //     discount_percentage : currentValues.discountPercent, /* percentage */
        //     discount_amount : currentValues.discount, 
        // }

        const items = currentValues.rows.map(item => {
            return {
                id: item?.itemId,
                doc_item_id: item?.docItemId,
                code: item?.code,
                name: item?.name,
                description: item?.description,
                qty: item?.qty,
                uom_lbl: item?.uomName,
                uom: item?.uomId,
                price: item?.price,
                // props: {
                //     slot: ""
                // }
            }
        })

        let adjustments = getPayloadSubmitCreate()

        try {

            let data = {
                document,
                profiles,
                // amounts,
                props,
                items,
                adjustments,
            }

            const response = await update({ id, data });

            // console.log('response', response)

            promptMessage(true, `${response?.message}`)

            navigate(getRoute(`documents/retailPrescription/view/${id}`))

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

    }

    const formik = useFormik({
        initialValues: savedValues,
        validationSchema,
        onSubmit,
        enableReinitialize: true
    });

    const { handleSubmit, handleChange, values, errors, touched, setFieldValue, } = formik;

    const {
        // getAmount,
        calculateSummaryRows,
        updateTaxPreviewOpen,
        RenderDocumentSummary,
        RenderDocumentTaxPreview,
        RenderDiscountSummary,
        getPayloadSubmitCreate,
        updateAdjustments
    } = useDocumentAdjustments({
        formik,
        disableTax: true,
        documentType: documentTypes.retailPrescription,
        handlePreviewChange: (val) => {
            // console.log('current open', val)
            setPreview(val)
        }
    })

    useEffect(() => {

        if (selectedAdjustments.length > 0)
            updateAdjustments(selectedAdjustments)

    }, [selectedAdjustments])

    useEffect(() => {

        calculateSummaryValues();

    }, [values])

    useEffect(() => {

        loadData(id)

    }, [])

    // useEffect(() => {

    //     const currentLocationIds = getLocationIds();

    //     console.log('currentLocationIds', currentLocationIds, availableLocations)

    //     setSelectLocationIds(currentLocationIds)

    //     if(currentLocationIds && currentLocationIds.length > 0){
    //         // console.log('currentLocationIds', currentLocationIds, availableLocations)

    //         // get the location information
    //         const loc = availableLocations.filter(item => item.id === currentLocationIds[0])

    //         if(loc.length){
    //             setFieldValue("locationId", loc[0].id)
    //             setFieldValue("locationName", loc[0].location_name)
    //         }
    //     }

    // }, [getLocationIds])

    // const calculateSummaryValues = () => {

    //     if (!values) return false;

    //     try {
    //         const { totalAmount } = calculateSummaryRows({
    //             formikValues: values,
    //             setFieldValue,
    //             handleValueRow: ({ subTotal, index }) => {
    //                 setFieldValue(`rows.${index}.subtotal`, subTotal.toFixed(2))
    //             },
    //             handleValueTax: ({ taxValues }) => {

    //                 Object.keys(taxValues).forEach((e) => {
    //                     setFieldValue(`tax.${e}`, taxValues[e])
    //                 })

    //             }
    //         })

    //         setFieldValue(`totalamount`, totalAmount.toFixed(2))

    //     } catch (error) {
    //         promptMessage(false, `Error in summary calculation : ${error}`)
    //     }

    //     return true;

    // }

    const calculateSummaryValues = () => {

        if (!values) return false;

        try {
            calculateSummaryRows({
                handleValueRow: ({ subTotal, index }) => {
                    setFieldValue(`rows.${index}.subtotal`, subTotal.toFixed(2))
                }
            })
        } catch (error) {
            promptMessage(false, `Error in summary calculation : ${error}`)
        }

        return true;

    }

    const handleAddItem = ({ rows, setFieldValue }) => {

        rows.push(initialRowValues);
        setFieldValue('rows', rows)

    }

    const handleRemoveItem = ({ rows, index, setFieldValue }) => {

        const currentLine = rows ? rows.length : 0;

        if (currentLine <= 1) {
            promptMessage(false, t(`itemsAtLeastHave1Row`))
            return false;
        }

        const newRows = rows.filter((i, ind) => ind !== index)

        // rows.remove(index);
        setFieldValue('rows', newRows)

        return true;

    }

    const RenderRows = () => {

        const rows = values?.rows;

        return (
            <Box
            >
                <Box
                >
                    {
                        rows && rows.length > 0
                        && rows.map((item, index) => {

                            const itemValues = item;
                            let itemTouched = touched?.rows
                            let itemErrors = errors?.rows
                            // const itemTouched = touched?.rows

                            if (itemTouched) {
                                itemTouched = (itemTouched[index] !== undefined) ? itemTouched[index] : {};
                            }

                            if (itemErrors) {
                                itemErrors = (itemErrors[index] !== undefined) ? itemErrors[index] : {};
                            }

                            return (
                                <Grid key={index} item xs={12} sm={12} md={12}>

                                    <Grid container spacing={0.5} >

                                        <Grid item xs={12} sm={12} md={0.5} alignSelf={"center"}>
                                            <IconButton
                                                aria-label="delete"
                                                onClick={() => handleRemoveItem({ rows: values.rows, index, setFieldValue })}
                                            >
                                                <CommonIcons name={icons.remove} />
                                            </IconButton>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={3.5}>

                                            <SearchItems
                                                id={`rows.${index}.name`}
                                                handleOnCancel={() => { }}
                                                handleOnSearchChange={(event) => {
                                                    setFieldValue(`rows.${index}.name`, `${event.target.value}`)
                                                }}
                                                handleOnSelect={({ id, item }) => {
                                                    // console.log('id', id, item)
                                                    setFieldValue(`rows.${index}.itemId`, item?.id)
                                                    setFieldValue(`rows.${index}.name`, item?.item_name)
                                                    setFieldValue(`rows.${index}.description`, item?.description)
                                                    setFieldValue(`rows.${index}.code`, item?.code)
                                                    setFieldValue(`rows.${index}.uomName`, item?.uom_name)
                                                    setFieldValue(`rows.${index}.uomId`, item?.uom_id)
                                                    setFieldValue(`rows.${index}.qty`, 1)
                                                    setFieldValue(`rows.${index}.price`, item?.uom_price)
                                                }}
                                                textProps={{
                                                    disabled: true,
                                                    value: itemValues?.name ? itemValues.name : "",
                                                    error: Boolean(itemErrors?.name),
                                                    helperText: itemErrors?.name
                                                }}
                                            />

                                        </Grid>

                                        <Grid item xs={12} sm={12} md={1}>
                                            <TextField
                                                disabled
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.uomName`}
                                                label={t("uom")}
                                                type="text"
                                                variant="outlined"
                                                value={itemValues?.uomName ? itemValues.uomName : ""}
                                                onChange={handleChange}
                                                error={Boolean(itemErrors?.uomName)}
                                                helperText={itemErrors?.uomName}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={3.5}>
                                            <TextField
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.description`}
                                                label={t("description")}
                                                type="text"
                                                variant="outlined"
                                                value={itemValues?.description ? itemValues.description : ""}
                                                onChange={handleChange}
                                                error={Boolean(itemErrors?.description)}
                                                helperText={itemErrors?.description}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={1}>
                                            <TextField
                                                inputProps={{
                                                    style: {
                                                        textAlign: "center"
                                                    }
                                                }}
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.qty`}
                                                label={t("qty")}
                                                type="text"
                                                variant="outlined"
                                                value={itemValues?.qty ? itemValues.qty : ""}
                                                onChange={(event) => {
                                                    setFieldValue(`rows.${index}.qty`, event.target.value);
                                                    // handleDisplayRowChange({ index, qty: event.target.value});
                                                }}
                                                error={Boolean(itemErrors?.qty)}
                                                helperText={itemErrors?.qty}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={1}>
                                            <TextField
                                                inputProps={{
                                                    style: {
                                                        textAlign: "right"
                                                    }
                                                }}
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.price`}
                                                label={t("price")}
                                                type="text"
                                                variant="outlined"
                                                value={itemValues?.price ? itemValues.price : ""}
                                                onChange={(event) => {
                                                    setFieldValue(`rows.${index}.price`, event.target.value);
                                                    // handleDisplayRowChange({ index, price: event.target.value});
                                                }}
                                                error={Boolean(itemErrors?.price)}
                                                helperText={itemErrors?.price}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={1.5}>
                                            <TextField
                                                inputProps={{
                                                    style: {
                                                        textAlign: "right"
                                                    }
                                                }}
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                disabled
                                                name={`rows.${index}.subtotal`}
                                                label={t("subTotal")}
                                                value={itemValues?.subtotal ? itemValues.subtotal : "0.00"}
                                                type="text"
                                                variant="outlined"
                                            />
                                        </Grid>

                                    </Grid>
                                </Grid>
                            )
                        })
                    }
                </Box>

                <Grid item xs={12}>
                    <Divider sx={{ mt: 1, mb: 0 }} />
                </Grid>

                {
                    RenderSummaryRow({ values, errors, touched, handleChange, setFieldValue })
                }

            </Box>
        )
    }

    // Discount (Adjustments Hook)
    const RenderSummaryRow = ({ values, errors, touched, handleChange, setFieldValue }) => {
        return (
            <Grid item xs={12} sm={12} md={12}>

                <Grid container spacing={0.5}>

                    <Grid item xs={12} sm={12} md={4}>

                        <Button
                            variant="outlined"
                            sx={{ mt: 2 }}
                            fullWidth
                            startIcon={<CommonIcons name={icons.add} />}
                            onClick={() => handleAddItem({ rows: values.rows, setFieldValue })}
                        >
                            {t("addItem")}
                        </Button>

                    </Grid>

                    <Grid item xs={12} sm={12} md={5.5}>
                        <></>
                    </Grid>

                    <Grid item xs={12} sm={12} md={2.5}>

                        {
                            RenderDocumentSummary()
                        }

                    </Grid>

                </Grid>

            </Grid>
        )
    }

    // const RenderFormLocation = () => {
    //     return (
    //         <StyledCard>
    //             <Grid container spacing={0.5}>
    //                 <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

    //                     <CommonSectionHeader
    //                         title={`Location`}
    //                         subTitle={`Related warehouse location to process`}
    //                     />                     

    //                 </Grid>
    //                 <Grid item xs={12} sm={12} md={12}>
    //                     <TextField
    //                         disabled
    //                         margin="dense"
    //                         size="small"
    //                         fullWidth
    //                         name={"locationId"}
    //                         label="Location"
    //                         type="text"                                         
    //                         variant="outlined"
    //                         value={values.locationName}
    //                         error={touched.locationId && Boolean(errors.locationId)}
    //                         helperText={touched.locationId && errors.locationId}
    //                     />
    //                 </Grid>
    //                 {/* <Grid item md={1.5}>
    //                     <IconButton
    //                         color="primary"
    //                         sx={{
    //                             // pt: 0
    //                         }}
    //                         onClick={() => {
    //                             // setLocationIds([])
    //                         }}
    //                     >
    //                         <StyledIcon
    //                             sx={{
    //                                 width: 25,
    //                                 height: 25,
    //                                 m: 0,
    //                                 p: 0
    //                             }}
    //                         >
    //                             <CommonIcons name={icons.edit} />
    //                         </StyledIcon>
    //                     </IconButton>
    //                 </Grid> */}

    //             </Grid>
    //         </StyledCard>
    //     )
    // }

    const RenderFormProfiles = () => {
        return (
            <StyledCard>

                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`profile`)}
                            subTitle={t(`relatedProfilesToProcess`)}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>

                        <SearchRetailMembers
                            id={"searchRetailMembers"}
                            ownerId={values?.retailerUserId ? values.retailerUserId : ""}
                            handleOnCancel={() => {

                            }}
                            handleOnSearchChange={(event) => {
                                setFieldValue('memberDisplay', `${event.target.value}`)
                            }}
                            handleOnSelect={({ id, item }) => {
                                setFieldValue('memberUserId', item?.user_id)
                                setFieldValue('memberDisplay', `${item?.firstname} ${item?.lastname}`)
                            }}
                            textProps={{
                                disabled: true,
                                value: values?.memberDisplay,
                                error: Boolean(errors?.memberUserId),
                                helperText: errors?.memberUserId,
                            }}
                        />

                    </Grid>
                    {/* <Grid item xs={12} sm={12} md={12}>
                        <FormControl
                            margin="dense"
                            fullWidth
                            size="small"
                            error={touched.billingBranchId && Boolean(errors.billingBranchId)}
                        >
                            <InputLabel id="rack-label">Bill To</InputLabel>
                            <Select
                                disabled
                                value={
                                    checkValueExists({ 
                                        searchFieldId: "id",
                                        dataSearch: dataBranches, 
                                        valueToCompare: values?.billingBranchId
                                    })
                                }
                                name={`billingBranchId`}
                                label="billingBranchId"
                                margin="dense"
                                size="small"
                                onChange={(event) => {
                                    setFieldValue(`billingBranchId`, event.target.value)
                                }}
                            >
                                {
                                    dataBranches && dataBranches.map((item, index) => 
                                        <MenuItem key={index} value={item.id}>{item.branch_name}</MenuItem>
                                    )
                                }
                            </Select>
                            <FormHelperText>
                                {touched.billingBranchId && errors.billingBranchId}
                            </FormHelperText>
                        </FormControl>
                    </Grid> */}

                    {/* <Grid item xs={12} sm={12} md={12}>
                        <FormControl
                            margin="dense"
                            fullWidth
                            size="small"
                            error={touched.shippingBranchId && Boolean(errors.shippingBranchId)}
                        >
                            <InputLabel id="rack-label">Ship To</InputLabel>
                            <Select
                                disabled
                                value={
                                    checkValueExists({ 
                                        searchFieldId: "id",
                                        dataSearch: dataShipping, 
                                        valueToCompare: values?.shippingBranchId
                                    })
                                }
                                name={`shippingBranchId`}
                                label="shippingBranchId"
                                margin="dense"
                                size="small"
                                onChange={(event) => {
                                    setFieldValue(`shippingBranchId`, event.target.value)
                                }}
                            >
                                {
                                    dataShipping && dataShipping.map((item, index) => 
                                        <MenuItem key={index} value={item.id}>{item.branch_name}</MenuItem>
                                    )
                                }
                            </Select>
                            <FormHelperText>
                                {touched.shippingBranchId && errors.shippingBranchId}
                            </FormHelperText>
                        </FormControl>
                    </Grid> */}

                </Grid>
            </StyledCard>
        )
    }

    const RenderFormDocument = () => {
        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`document`)}
                            subTitle={t(`basicInformationAboutTheDocument`)}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={0.5}>

                            <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                                <TextField
                                    disabled
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"documentNumber"}
                                    label={t("docNumber")}
                                    type="text"
                                    variant="outlined"
                                    value={values?.documentNumber}
                                // onChange={handleChange}
                                // error={touched.documentNumber && Boolean(errors.documentNumber)}
                                // helperText={touched.documentNumber && errors.documentNumber}
                                />

                            </Grid>

                            <Grid item xs={12} sm={12} md={6} textAlign={"left"}>
                                <TextField
                                    disabled
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"locationId"}
                                    label={t("location")}
                                    type="text"
                                    variant="outlined"
                                    value={values.locationName}
                                // error={touched.locationId && Boolean(errors.locationId)}
                                // helperText={touched.locationId && errors.locationId}
                                />
                            </Grid>


                            <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                                <DatePickerComponent
                                    config={{
                                        name: "documentDate",
                                        label: t("documentDate")
                                    }}
                                    formik={{
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        setFieldValue
                                    }}
                                    sx={{
                                        width: '100%'
                                    }}
                                />

                            </Grid>

                            <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"remark"}
                                    label={t("remark")}
                                    type="text"
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    value={values?.remark}
                                    onChange={handleChange}
                                    error={touched.remark && Boolean(errors.remark)}
                                    helperText={touched.remark && errors.remark}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"note"}
                                    label={t("privateNote")}
                                    type="text"
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    value={values?.note}
                                    onChange={handleChange}
                                    error={touched.note && Boolean(errors.note)}
                                    helperText={touched.note && errors.note}
                                />
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderForm = () => {

        if (!values) return <></>

        return (
            <form onSubmit={handleSubmit}>

                <Grid container spacing={1}>

                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>
                        {
                            RenderFormDocument()
                        }
                    </Grid>


                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                        {/* {
                                RenderFormLocation()
                            } */}

                        {
                            RenderFormProfiles()
                        }

                    </Grid>

                </Grid>
                <StyledCard sx={{ mt: 1 }}>
                    <Grid container rowSpacing={0}>
                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                            <CommonSectionHeader
                                title={t(`items`)}
                                subTitle={t(`detailInformationAboutTheItemsInvolved`)}
                            />

                        </Grid>

                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                            {
                                RenderRows()
                            }

                            {/* <FieldArray
                                    name="rows"
                                    render={(arrayHelpers) => {
                                        
                                        return RenderRow({ values, errors, touched, handleChange, setFieldValue, arrayHelpers})
                                    
                                    }}
                                /> */}
                        </Grid>

                    </Grid>
                </StyledCard>
                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        <LoadingButton
                            type="submit"
                            // fullWidth
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                            loading={isLoading}
                        >
                            {t('saveChanges')}
                        </LoadingButton>
                    </Grid>
                </Grid>

            </form>
        )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.updateRetailPrescription })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("updateRetailPrescription")}
                breadcrumbs={[
                    {
                        displayText: t("retailPrescriptions"),
                        props: {
                            href: getRoute('documents/retailPrescriptions')
                        }
                    },
                    {
                        displayText: t("updateRetailPrescription"),
                        props: {
                            color: 'secondary.main',
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) ?
                    RenderForm()
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    )
}